<script setup lang="ts">
import { useRideStore } from '../../stores/rideStore';
import type { DirectionFilter, RideFilter } from '../../types/ride';
import { useSwipe } from '@vueuse/core';
import { ref } from 'vue';

const store = useRideStore();
const headerRef = ref<HTMLElement | null>(null);

useSwipe(headerRef, {
  onSwipeStart: (e) => {
    e.preventDefault();
  },
  onSwipe: (e) => {
    e.preventDefault();
  },
  onSwipeEnd: (e, direction) => {
    if (direction === 'left' && store.selectedDirection === 'from_bm') {
      store.selectedDirection = 'to_bm';
    } else if (direction === 'right' && store.selectedDirection === 'to_bm') {
      store.selectedDirection = 'from_bm';
    }
  },
});
</script>

<template>
  <div ref="headerRef" class="rides-header">
    <div class="direction-tabs">
      <button
        v-for="direction in [{ id: 'from_bm', label: 'Von BM' }, { id: 'to_bm', label: 'Nach BM' }]"
        :key="direction.id"
        :class="{ active: store.selectedDirection === direction.id }"
        @click="store.selectedDirection = direction.id"
      >
        {{ direction.label }}
      </button>
    </div>

    <div class="filter-tabs">
      <button
        v-for="filter in ['all', 'offer', 'request']"
        :key="filter"
        :class="{ active: store.selectedFilter === filter }"
        @click="store.selectedFilter = filter"
      >
        {{ filter === 'all' ? 'Alle' : filter === 'offer' ? 'Angebote' : 'Gesuche' }}
      </button>
    </div>
  </div>
</template>

<style scoped>
.rides-header {
  position: sticky;
  top: 0;
  z-index: 10;
  background: #f5f5f5;
  padding: 1rem 1rem 0;
  touch-action: none;
}

.direction-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  background: white;
  padding: 0.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.direction-tabs button {
  flex: 1;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  background: none;
  color: #666;
  cursor: pointer;
  font-weight: 500;
  font-size: 1.1rem;
}

.direction-tabs button.active {
  background: #960040;
  color: white;
}

.filter-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1rem;
  background: white;
  padding: 0.5rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
}

.filter-tabs button {
  flex: 1;
  padding: 0.5rem;
  border: none;
  border-radius: 4px;
  background: none;
  color: #666;
  cursor: pointer;
}

.filter-tabs button.active {
  background: #960040;
  color: white;
}
</style>